import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useInView } from "framer-motion";
import { Sparkles } from "lucide-react";

export function Logo({ light = false, className = "" }) {
    return (
        <Link to="/" className={`inline-flex items-baseline gap-1.5 ${className}`} data-testid="brand-logo">
            <span className={`font-display text-xl font-700 tracking-tight ${light ? "text-white" : "text-primary"}`}>Single</span>
            <span className={`font-display text-xl font-700 tracking-tight ${light ? "text-white/80" : "text-accent"}`}>Social&nbsp;Club</span>
        </Link>
    );
}

export function Spinner({ className = "" }) {
    return <div className={`h-6 w-6 rounded-full border-2 border-primary/20 border-t-primary animate-spin ${className}`} />;
}

export function PageLoader() {
    return (
        <div className="flex min-h-[50vh] items-center justify-center">
            <Spinner className="h-9 w-9" />
        </div>
    );
}

export const RATING_FACES = [
    { key: "great", label: "Great", emoji: "😀" },
    { key: "good", label: "Good", emoji: "🙂" },
    { key: "okay", label: "Okay", emoji: "😐" },
    { key: "not_great", label: "Not Great", emoji: "🙁" },
];

export function Typewriter({ text, speed = 45, startDelay = 400, className = "" }) {
    const [n, setN] = useState(0);
    useEffect(() => {
        let i = 0;
        let interval;
        const start = setTimeout(() => {
            interval = setInterval(() => {
                i += 1;
                setN(i);
                if (i >= text.length) clearInterval(interval);
            }, speed);
        }, startDelay);
        return () => { clearTimeout(start); clearInterval(interval); };
    }, [text, speed, startDelay]);
    return (
        <span className={className} aria-label={text}>
            {text.slice(0, n)}
            <span className="tw-caret" aria-hidden="true">|</span>
        </span>
    );
}

export function ScrollTypewriter({ text, speed = 40, className = "" }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, amount: 0.5 });
    return (
        <span ref={ref} className={className}>
            {inView ? <Typewriter text={text} speed={speed} startDelay={150} />
                    : <span className="opacity-0" aria-hidden="true">{text}</span>}
        </span>
    );
}

export function formatDate(d) {
    if (!d) return "TBD";
    try {
        return new Date(d + "T00:00:00").toLocaleDateString("en-US", {
            weekday: "long", month: "long", day: "numeric",
        });
    } catch {
        return d;
    }
}

export function formatTime(t) {
    if (!t) return "";
    const [h, m] = t.split(":").map(Number);
    const ampm = h >= 12 ? "PM" : "AM";
    const hr = h % 12 || 12;
    return `${hr}:${String(m).padStart(2, "0")} ${ampm}`;
}
